import breakfast_img from "../../../../../assets/images/food-items/meal-img.png"
import lunch_img from "../../../../../assets/images/food-items/lunch-img.png"
import dinner_img from "../../../../../assets/images/food-items/dinner-img.png"
import noodles_img from "../../../../../assets/images/food-items/noodles-img.png"
import pizza_img from "../../../../../assets/images/food-items/pizza-img.png"
import salad_img from "../../../../../assets/images/food-items/salads-img.png"
import beverages_img from "../../../../../assets/images/food-items/beverages-img.png"
import icecream_img from "../../../../../assets/images/food-items/ice-cream-img.png"
import tea_coffee_img from "../../../../../assets/images/food-items/tea-coffee-img.png"
import snacks_img from "../../../../../assets/images/food-items/snacks-img.png"

export const foodItemTypes = [
    {
        id: 1,
        item_type: 'Breakfast',
        item_image: breakfast_img,
    },
    {
        id: 2,
        item_type: 'Lunch',
        item_image: lunch_img,
    },
    {
        id: 3,
        item_type: 'Dinner',
        item_image: dinner_img,
    },
    {
        id: 4,
        item_type: 'Noodles',
        item_image: noodles_img,
    },
    {
        id: 5,
        item_type: 'Pizza',
        item_image: pizza_img,
    },
    {
        id: 6,
        item_type: 'Salads',
        item_image: salad_img,
    },
    {
        id: 7,
        item_type: 'Beverages',
        item_image: beverages_img,
    },
    {
        id: 8,
        item_type: 'Ice Cream',
        item_image: icecream_img,
    },
    {
        id: 9,
        item_type: 'Tea & Coffee',
        item_image: tea_coffee_img
    },
    {
        id: 10,
        item_type: 'Snacks',
        item_image: snacks_img,
    },
]

export const foodItems = [
    {
        id: 1,
        meal_type: {
            type: 'Breakfast',
            item_name: 'Pancakes',
            price: "₹189",
            item_image: breakfast_img,
            rating: "4.9"
        }
    }
]

export const cartItemsData = [
    {
        id: 1,
        name: 'Full Meal',
        price: 378.00,
        quantity: 2,
        image: breakfast_img,
    },
    {
        id: 2,
        name: 'Tea',
        price: 35.00,
        quantity: 1,
        image: tea_coffee_img
    },
    {
        id: 3,
        name: 'Snacks',
        price: 99.00,
        quantity: 1,
        image: snacks_img
    }
]

